import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Menu = () => {
  const { t, i18n } = useTranslation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolling, setScrolling] = useState(false);
  const isMobile = window.innerWidth <= 768;

  // Get the current path from the URL (e.g., '', 'services', 'contact')
  const currentPath = window.location.pathname.split('/')[1];

  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(`/${path}`);
    setMobileOpen(false);
  };

  const toggleMobileMenu = () => {
    setMobileOpen(!mobileOpen);
  };

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolling(true);
      } else {
        setScrolling(false);
      }
    };

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleScroll = (id) => {
    if (currentPath !== '') {
      navigate(`/`);
    }
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        window.scrollTo({
          top: element.offsetTop - 80,
          behavior: 'smooth',
        });
        setMobileOpen(false);
      }
    }, 500);
  };

  const menuItems = [
    { label: t('home'), link: '' },
    { label: t('deliveryService'), link: 'services' },
    { label: 'Contact', link: 'contact' },
  ];

  return (
    <div>
      <AppBar
        position="fixed"
        elevation={0}
        style={{
          backgroundColor: scrolling ? '#FFFFFF' : 'transparent',
          transition: 'background-color 0.3s ease-in-out',
          zIndex: 1100,
        }}
      >
        <Toolbar
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '10px 10%',
          }}
        >
          <img src="/img/logo-tsg.svg" alt="Logo" width={180} />

          <Box
            className="menu-desktop"
            sx={{
              display: { xs: 'none', md: 'flex' },
              gap: '20px',
              alignItems: 'center',
            }}
          >
            {menuItems.map((item, index) => (
              <Button
                key={index}
                sx={{
                  color: '#000000',
                  fontWeight: currentPath === item.link ? 'bold' : 'normal',
                }}
                onClick={() => handleNavigate(item.link)}
              >
                {item.label}
              </Button>
            ))}

            <Button
              onClick={() => handleScroll('section2')}
              variant="contained"
              style={{
                backgroundColor: '#000',
                color: '#fff',
                borderRadius: '20px',
                padding: '8px 20px',
                textTransform: 'none',
              }}
            >
              {t('deliveryRequest')}
            </Button>
            {/* Lang change */}
            <Button
              onClick={() =>
                i18n.changeLanguage(i18n.language === 'en' ? 'fr' : 'en')
              }
              variant="text"
              style={{
                color: '#000',
                padding: '8px 20px',
                textTransform: 'none',
              }}
            >
              {i18n.language === 'en' ? 'FR' : 'EN'}
            </Button>
          </Box>
          {isMobile && (
            <Button
              onClick={() =>
                i18n.changeLanguage(i18n.language === 'en' ? 'fr' : 'en')
              }
              variant="text"
              style={{
                color: '#000',
                padding: '8px 20px',
                textTransform: 'none',
              }}
            >
              {i18n.language === 'en' ? 'FR' : 'EN'}
            </Button>
          )}

          <IconButton
            color="black"
            sx={{
              display: { xs: 'block', sm: 'block', md: 'none' },
            }}
            aria-label="menu"
            onClick={toggleMobileMenu}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer anchor="right" open={mobileOpen} onClose={toggleMobileMenu}>
        <div style={{ width: 250, padding: '10px' }}>
          <List>
            {menuItems.map((item, index) => (
              <ListItem
                button='true'
                key={index}
                onClick={() => handleNavigate(item.link)}
              >
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{
                    fontWeight: currentPath === item.link ? 'bold' : 'normal',
                  }}
                />
              </ListItem>
            ))}
            <ListItem button onClick={() => handleScroll('section2')}>
              <Button
                fullWidth
                variant="contained"
                style={{
                  backgroundColor: '#000',
                  color: '#fff',
                  borderRadius: '20px',
                  padding: '10px',
                  textTransform: 'none',
                }}
              >
                {t('deliveryRequest')}
              </Button>
            </ListItem>
          </List>
        </div>
      </Drawer>
    </div>
  );
};

export default Menu;
